export default {
  INIT: 'init',
  NONE: 'none',
  PROCESS_SELECTION: 'processSelection',
  RESET_SELECTION: 'resetSelection'
};
